import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["value", "className", "format", "showCustomInput", "placeholder", "onChange", "minDate", "maxDate", "showClearButton"],
    _excluded2 = ["control"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { CalendarIcon } from '@heroicons/react/outline';
import { ClearOutlined } from '@mui/icons-material';
import clsx from 'clsx';
import PrimitiveDatePicker from 'react-date-picker/dist/entry.nostyle';
import { Controller } from 'react-hook-form';
import { formatDate } from '../../shared/formatters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DatePicker(_ref) {
  var value = _ref.value,
      className = _ref.className,
      format = _ref.format,
      showCustomInput = _ref.showCustomInput,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      showClearButton = _ref.showClearButton,
      props = _objectWithoutProperties(_ref, _excluded);

  var today = new Date();
  var tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  var displayValue = placeholder !== null && placeholder !== void 0 ? placeholder : 'Add your date';

  if (Array.isArray(value)) {
    if (value.every(function (i) {
      return !!i;
    })) {
      var _value$0$toString, _value$, _value$1$toString, _value$2;

      displayValue = "".concat(formatDate({
        date: (_value$0$toString = value === null || value === void 0 ? void 0 : (_value$ = value[0]) === null || _value$ === void 0 ? void 0 : _value$.toString()) !== null && _value$0$toString !== void 0 ? _value$0$toString : '',
        options: {
          month: '2-digit'
        }
      }), " - ").concat(formatDate({
        date: (_value$1$toString = value === null || value === void 0 ? void 0 : (_value$2 = value[1]) === null || _value$2 === void 0 ? void 0 : _value$2.toString()) !== null && _value$1$toString !== void 0 ? _value$1$toString : '',
        options: {
          month: '2-digit'
        }
      }));
    }
  } else if (value) {
    var _value$toString;

    displayValue = formatDate({
      date: (_value$toString = value === null || value === void 0 ? void 0 : value.toString()) !== null && _value$toString !== void 0 ? _value$toString : '',
      options: {
        month: '2-digit'
      }
    });
  }

  return /*#__PURE__*/_jsxs("div", {
    className: "relative",
    children: [showCustomInput && /*#__PURE__*/_jsx("div", {
      className: "absolute left-1 top-1/2 z-10 flex -translate-y-1/2 truncate whitespace-nowrap bg-white pl-2",
      style: {
        width: 'calc(100% - 50px)'
      },
      children: /*#__PURE__*/_jsx("span", {
        className: "numeric-font-fix w-full truncate px-2 text-sm",
        children: displayValue
      })
    }), /*#__PURE__*/_jsx(PrimitiveDatePicker, _objectSpread({
      className: clsx('focus:border-primary-500 focus:ring-primary-500 -y-4 w-full rounded-lg border border-neutral-300 bg-white', {
        'p-4': !className
      }, className),
      clearIcon: showClearButton ? /*#__PURE__*/_jsx(ClearOutlined, {}) : null,
      calendarIcon: /*#__PURE__*/_jsx(CalendarIcon, {
        className: "h-5 w-5 text-gray-500"
      }),
      value: value,
      onChange: onChange,
      locale: "en-GB",
      minDate: minDate ? minDate : props.allowPastDates ? new Date() : value,
      maxDate: maxDate !== null && maxDate !== void 0 ? maxDate : new Date(2050, 11, 31),
      format: format
    }, props))]
  });
}
export default DatePicker;
export var DatePickerControlled = function DatePickerControlled(_ref2) {
  var control = _ref2.control,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({
    control: control
  }, props), {}, {
    render: function render(_ref3) {
      var _ref3$field = _ref3.field,
          value = _ref3$field.value,
          onChange = _ref3$field.onChange,
          onBlur = _ref3$field.onBlur;
      return /*#__PURE__*/_jsx(DatePicker, _objectSpread({
        className: "px-3 py-2",
        value: value,
        onChange: onChange,
        onCalendarClose: onBlur
      }, props));
    }
  }));
};